import { useMemo } from 'react';

import InsightsTabsFilterBar from 'components/insights/filterBar/InsightsTabsFilterBar';
import { FilterSection } from 'components/shared/filters/FilterSlideout';
import { TabType } from 'components/Tabs';
import { PREDECESSOR_GROUP_TYPE, PREDECESSOR_LOCATION } from 'constants/filterKeysConstants';
import { useNetworkPerformanceActions, useNetworkPerformanceStore } from 'stores/networkPerformanceStore';

import { filtersForGroupType, getFilterSections } from '../../filters';
import { useNetworkPerformanceContext } from '../NetworkPerformanceContainer';

type Props = {
  tabs: TabType[];
  selectedTab?: TabType;
  onTabClick: (tab: TabType) => void;
};

export default function NetworkPerformanceFilterBar({ tabs, selectedTab, onTabClick }: Props) {
  const { predecessorGroupTypes } = useNetworkPerformanceContext();
  const selectedGroupType = useNetworkPerformanceStore((state) => state.selectedGroupType);
  const filters = useNetworkPerformanceStore((state) => state.filters);
  const { setSelectedFilters } = useNetworkPerformanceActions();

  const filterSections = useMemo(
    () =>
      getFilterSections({
        predecessorGroupTypes,
        selectedGroupType,
      }),
    [predecessorGroupTypes, selectedGroupType]
  );

  const activeFilters = useMemo(
    () =>
      selectedGroupType
        ? filtersForGroupType(filters, selectedGroupType, PREDECESSOR_LOCATION, PREDECESSOR_GROUP_TYPE)
        : filters,
    [filters, selectedGroupType]
  );

  return (
    <InsightsTabsFilterBar
      title='Post Discharge Dashboard'
      gtmPrefix='postDischargeDashboard'
      tabs={tabs}
      selectedTab={selectedTab}
      onTabClick={onTabClick}
      filters={activeFilters}
      filterSections={filterSections as FilterSection[]}
      setSelectedFilters={setSelectedFilters}
    />
  );
}
